module.exports = __webpack_public_path__ + "static/img/noData.45b9a528.svg";